import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

function clickOnShowDetails(e) {
  const category = GA_EVENTS.vehiclePersonalisedPage.category;
  const action = GA_EVENTS.vehiclePersonalisedPage.actions.clickOnShowDetails;
  const href = location.href;
  let label = href.substring(href.indexOf('/vehicles/') + 10, href.indexOf('/tyres'));
  label = label.replace('/', '_');

  const spinachId = e.currentTarget?.href || '';
  const value = spinachId
    ? spinachId.substring(spinachId.lastIndexOf('-') + 1, spinachId.lastIndexOf('.')).toUpperCase()
    : '';

  setBehaviourEvent({ category, action, label, value });
  setFunnelyticsBehaviourEvent({ category, action, label, value });
}

function clickOnSeeAllAvailableVehicle(e) {
  const category = GA_EVENTS.vehiclePersonalisedPage.category;
  const action = GA_EVENTS.vehiclePersonalisedPage.actions.clickOnSeeAllAvailableVehicle;
  let href = location.href;
  let label = href.substring(href.indexOf('/vehicles/') + 10, href.indexOf('/tyres'));
  label = label.replace('/', '_');

  href = e.currentTarget?.href || '';
  const value = href;

  setBehaviourEvent({ category, action, label, value });
  setFunnelyticsBehaviourEvent({ category, action, label, value });
}

export { clickOnShowDetails, clickOnSeeAllAvailableVehicle };
